import * as Comprehensive from "@/service/Comprehensive.js";
export default {
    namespaced: true,
    state: {
        rules: {
            provider_name: [
                { required: true, message: "请输入服务器名称", trigger: "blur" },
            ],
            provider_address: [
                { required: true, message: "请输入服务器IP", trigger: "blur" },
            ],
            service_level: [
                { required: true, message: "请选择模板描述", trigger: "change" },
            ],
            service_max_power: [
                { required: true, message: "请选择模板描述", trigger: "change" },
            ],
            provider_remark: [
                { required: true, message: "请输入备注", trigger: "blur" },
            ],
        },
    },
    actions: {
        //添加服务器
        addServerSto({ commit }, data) {
            return Comprehensive.addServerSer(data);
        },
        //获取服务器列表
        getServerListSto({ commit }, data) {
            return Comprehensive.getServerListSer(data);
        },
        //添加服务器
        editServerSto({ commit }, data) {
            return Comprehensive.editServerSer(data);
        },
        //删除服务器
        deleteServerSto({ commit }, data) {
            return Comprehensive.deleteServerSer(data);
        },
    },
};